import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import "./kundaliChart.scss";

export default function KundaliNavam({ date }) {
  const canvasRef = useRef(null);
  const [navamsa, setNavamsa] = useState({});
  const [ascSign, setAscSign] = useState(null);

  // North Indian chart slots
  const houseSlots = {
    1: [[10, 50], [30, 80], [30, 110]],     
    2: [[110, 220], [160, 200], [110, 240]],
    3: [[340, 300], [310, 300], [340, 280]],
    4: [[320, 110], [340, 110], [360, 140], [370, 120]],
    5: [[190, 230], [190, 250]],
    6: [[290, 360], [290, 320], [290, 340]],
    7: [[20, 290], [60, 300]],
    8: [[90, 330], [110, 330], [50, 330]],
    9: [[240, 200], [210, 210], [180, 220]],
    10: [[290, 50], [290, 70]],
    11: [[200, 90], [200, 120], [180, 170]],
    12: [[80, 50], [80, 30], [80, 80]],
  };

  // Fetch navamsa data
  useEffect(() => {
        if (!date ) return;

    axios
      .get("https://core-c343.onrender.com/api/navamsa", {
        params: {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate(),
          hour: date.getHours(),
          minute: date.getMinutes(),
          timezone: "Asia/Kolkata",
        
        },
        
      })
      .then((res) => {
        const data = res.data;
        const positions = data.navamsaPositions;

        // Convert navamsaPositions → house structure
        // Example: if Sun is in Cancer → house 4 (Cancer = 4th sign)
        const houses = {};
        Object.keys(positions).forEach((planet) => {
          const { sign, signIndex, degree } = positions[planet];
          if (!houses[signIndex + 1]) houses[signIndex + 1] = [];
          houses[signIndex + 1].push({
            name: planet,
            degree,
          });
        });

        setNavamsa(houses);

        // Ascendant for navamsa = signIndex of D9 lagna
        // If not given, derive manually (here we assume D9 lagna = Sun sign)
        const asc = positions.sun?.signIndex + 1 || 1;
        setAscSign(asc);
      })
      .catch((err) => {
        console.error("Error fetching navamsa:", err);
      });
  }, [date]);

  // Rotate chart houses
  const getRotatedHouseNumber = (slot) => {
    if (!ascSign) return slot;
    return ((ascSign - 1 + slot - 1) % 12) + 1;
  };

  // Draw Navamsa chart
  useEffect(() => {
    if (!canvasRef.current || Object.keys(navamsa).length === 0 || !ascSign)
      return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Draw outer diamond
    ctx.beginPath();
    ctx.moveTo(200, 0);
    ctx.lineTo(400, 200);
    ctx.lineTo(200, 400);
    ctx.lineTo(0, 200);
    ctx.closePath();
    ctx.strokeStyle = "#e77d0bff";
    ctx.lineWidth = 2;
    ctx.stroke();

    // Draw cross lines
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(400, 400);
    ctx.moveTo(400, 0);
    ctx.lineTo(0, 400);
    ctx.stroke();

    // Draw planets
    Object.keys(houseSlots).forEach((slot) => {
      const realHouseNum = getRotatedHouseNumber(parseInt(slot));
      const items = navamsa[realHouseNum] || [];
      const positions = houseSlots[slot];

      items.forEach((item, idx) => {
        const pos = positions[idx] || positions[0];
        ctx.fillStyle = "black";
        ctx.font = "16px roboto";
        ctx.fillText(`${item.name}`, pos[0], pos[1]);
      });
      // Draw house number inside each slot
      const numPos = positions[0]; // pick first coordinate of slot
      ctx.fillStyle = "orange";
      ctx.font = "12px Arial";
      ctx.fillText(realHouseNum.toString(), numPos[0], numPos[1] - 10);
    });
  }, [navamsa, ascSign]);

  return (
    <div className="kundalii-container" style={{ textAlign: "center" }}>
      <h3>Navamsa (D9) Chart</h3>
      <canvas
        className="canvas"
        ref={canvasRef}
        width={400}
        height={400}
        style={{ border: "1px solid black" }}
      ></canvas>
    </div>
  );
}